import emailjs from "@emailjs/browser";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { FaInstagram } from "react-icons/fa";
import { PiYoutubeLogo } from "react-icons/pi";
import { PiFacebookLogo } from "react-icons/pi";
import { FaMapMarkerAlt } from "react-icons/fa";
const Contact = () => {
      const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      "service_fdt9cv6",
      "template_lfuu99p",
      form.current,
      {
        publicKey: "n0wlCxV3Oe648trfm",
      }
    )
    .then(() => {
      alert("Message sent successfully!");
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  };
    return (
        <section id='PageContact'>
        <div className="container m-auto w-4/5 py-20">
            <div className="row grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-20">
                <div className='ContactForm'>
                    <h4 className="font-bold">Feel Free to Write Our Experts</h4>
                    <form ref={form} onSubmit={sendEmail}>
                        <div className='flex gap-5'>
                            <div className='inputField my-5 w-full'>
                                <label className="my-3">First Name</label>
                                <input type="text" id="fname" placeholder="First Name" className="w-full my-2"  />
                            </div>
                            <div className='inputField  my-5 w-full'>
                                <label className="my-3">Last Name</label>
                                <input type="text" id="Lname" placeholder="Last Name" className="w-full my-2"  />
                            </div>
                        </div>

                        <div className='inputField'>
                            <label className="my-3">Email</label>
                            <input type="Email" id="email" placeholder="Email Id" className="w-full my-2" />
                        </div>
                        <div className='inputField  my-5'>
                            <label className="my-3">Description</label>
                            <textarea id='description' className="w-full my-2" >
                            </textarea>
                        </div>
                        <div className='inputField  my-5'>
                            <input type="submit" value="Send Request" />
                        </div>
                    </form>
                </div>
                <div className="ContactInfo">
                    <h4 className="font-bold ">Get in Touch And We’ll
Help Your Business</h4>
                    <div className="FollowUs mt-5">
                                          <h4 className="py-2 text-black font-bold">Follow Us On</h4>
                                          <ul className="flex gap-5">
                                           <li className="text-black"><FaInstagram /></li>
                                           <li className="text-black"><PiYoutubeLogo /></li>
                                           <li className="text-black"><PiFacebookLogo /></li>
                                          </ul>
                                       </div>
                                       <div className='my-3'>
                                          <h4 className="py-2 text-black font-bold">Address</h4>
                                          <p className="text-black flex items-center">
                                           <span className="mr-3 text-black"><FaMapMarkerAlt /></span>
                                           27, Tiwari Nagar, Rajendra Nagar, Indore(M.P) <br></br> India
                                          </p>
                                       </div>
                </div>
            </div>
        </div>
        </section>

    )
}
export default Contact;